import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading, Text } from '#/components/ui/typography'


export default function ChargerLoading() {
  const { t } = useTranslation([ 'chargers' ])
  const params = useParams() as { chargerId: string }
  const { state } = useLocation()

  // Display name might be available from nav state
  const chargerName = state?.name ?? params.chargerId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={chargerName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{chargerName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <Text>{t('view_charger.loading')}</Text>

    </div>
  )
}
